import React, { useEffect, useState } from "react";
import Constants from "../../utilities/js/Constants";
import "./LandingBracketPanels.css";
import { navigateToAccountPage } from "utilities/js/NavigationHelper";
import { getFollows } from "utilities/js/callouts/CalloutFactory";
import LoadingDisplay from "./LoadingDisplay";
import { NavigatorWrapper } from "./NavigatorWrapper";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

const FollowPanel = (props) => {

    const navigate = useNavigate();

    const followResponse = useQuery({
        queryKey: ['follow'], 
        queryFn: () => getFollows({list: 'all'}), 
        staleTime: 1000*60,
        retry: false
    });


    let follows = null;
    if(followResponse.isSuccess){
        follows = {};
        follows.following = followResponse.data.following.map(follow => {
            return {username: follow.user_id.username, id: follow.user_id._id, color: follow.user_id.color};
        })
        follows.followers = followResponse.data.followers.map(follow => {
            return {username: follow.follower_id.username, id: follow.follower_id._id, color: follow.follower_id.color};
        })
    }

    if(followResponse.isError){
        console.log(followResponse.error);
        follows = {following: [], followers: []};
    }


    
    const [selectedTab, setSelectedTab] = useState(props.defaultTab || 'followers');


    useEffect(() => {
        document.querySelector('.panel-tab[data-tab="'+ selectedTab + '"]').classList.add('selected');
    }, [selectedTab])


    
    function handleSelectedTab(event){
        setSelectedTab(event.currentTarget.dataset.tab);
        document.querySelectorAll(".panel-tab").forEach(tab => {
            tab.classList.remove('selected');
        })
        event.currentTarget.classList.add('selected');
    }

    function navigateToAccount(event){
        let accountId = event.currentTarget.dataset.id;
        navigateToAccountPage({
            accountId, 
            routerNav: navigate
        });
    }
    
    function getListToDisplay(){
        if(follows){
            if(selectedTab === 'following'){
                return follows.following;
            }else if(selectedTab === 'followers'){
                return follows.followers;
            }
        }
    }

    function getEmptyListMessage(){

        if(selectedTab === 'following'){
            return Constants.FOLLOW_MESSAGE_NO_FOLLOWING;
        }else if(selectedTab === 'followers'){
            return Constants.FOLLOW_MESSAGE_NO_FOLLOWERS;
        }
    }

    function getFollowDisplay(){

        if(followResponse.isLoading){
            return (<LoadingDisplay isLoading={followResponse.isLoading}></LoadingDisplay>);
        }else{
            let listToView = [];
            let listToDisplay = getListToDisplay();
            if(listToDisplay.length > 0){
                listToView = listToDisplay.map(follow => {
                    
                    let userColor = follow.color;

                    return (
                    <div key={follow.id} className="clickable-list-item">
                        <div className="clickable-list-item-main-inline" data-id={follow.id} onClick={navigateToAccount}>
                            <div className="account-icon-indicator" style={{backgroundColor: userColor}}>{follow.username.substring(0,1)}</div>
                            <div className="list-item-label">{follow.username}</div>
                        </div>
                        {/* <img className="open-new-tab-icon" alt="open-new-tab" src={openNewTabIcon}></img> */}
                    </div>
                    )
                });
            }else{
                return (<div className="empty-bracket-list">{getEmptyListMessage()}</div>);
            }

            return listToView
        }
    }

        
    return (
        <>
            
            <div className="panel-tab-container">
                <div className="panel-tab" data-tab="following" onClick={handleSelectedTab}>Following</div>
                <div className="panel-tab" data-tab="followers" onClick={handleSelectedTab}>Followers</div>
            </div>
            <div className="bracket-id-list">
                {getFollowDisplay()}
            </div>
            
        </>
    );


}

export default FollowPanel;

// class FollowPanel extends React.Component {
    
//     constructor(props){
//         super(props);
//         this.state = {
//             follows: null,
//             selectedTab: this.props.defaultTab || 'followers',
//             loading: true
//         };
        
//         this.navigateToAccount = this.navigateToAccount.bind(this);
//         this.handleSelectedTab = this.handleSelectedTab.bind(this);
//         this.handleSelectedTab = this.handleSelectedTab.bind(this);
        
//     }

//     async componentDidMount(){
//         try{
//             let rawFollows = await getFollows({list: 'all'});
//             let follows = {};
//             follows.following = rawFollows.following.map(follow => {
//                 return {username: follow.user_id.username, id: follow.user_id._id, color: follow.user_id.color};
//             })
//             follows.followers = rawFollows.followers.map(follow => {
//                 return {username: follow.follower_id.username, id: follow.follower_id._id, color: follow.follower_id.color};
//             })
//             this.setState({follows: follows});
//         }catch(error){
//             console.log(error);
//         }finally{
//             this.setState({loading: false});
//             document.querySelector('.panel-tab[data-tab="'+ this.state.selectedTab + '"]').classList.add('selected');
//         }
//     }
    
//     handleSelectedTab(event){
//         this.setState({selectedTab: event.currentTarget.dataset.tab});
//         document.querySelectorAll(".panel-tab").forEach(tab => {
//             tab.classList.remove('selected');
//         })
//         event.currentTarget.classList.add('selected');
//     }

//     navigateToAccount(event){
//         let accountId = event.currentTarget.dataset.id;
//         navigateToAccountPage({
//             accountId, 
//             routerNav: this.props.navigate
//         });
//     }
    
//     get listToDisplay(){
//         if(this.state.follows){
//             if(this.state.selectedTab === 'following'){
//                 return this.state.follows.following;
//             }else if(this.state.selectedTab === 'followers'){
//                 return this.state.follows.followers;
//             }
//         }
//     }

//     get emptyListMessage(){

//         if(this.state.selectedTab === 'following'){
//             return Constants.FOLLOW_MESSAGE_NO_FOLLOWING;
//         }else if(this.state.selectedTab === 'followers'){
//             return Constants.FOLLOW_MESSAGE_NO_FOLLOWERS;
//         }
//     }

//     get followDisplay(){

//         if(this.state.loading){
//             return (<LoadingDisplay isLoading={this.state.loading}></LoadingDisplay>);
//         }else{
//             let listToView = [];
//             if(this.listToDisplay.length > 0){
//                 listToView = this.listToDisplay.map(follow => {
                    
//                     let userColor = follow.color;

//                     return (
//                     <div key={follow.id} className="clickable-list-item">
//                         <div className="clickable-list-item-main-inline" data-id={follow.id} onClick={this.navigateToAccount}>
//                             <div className="account-icon-indicator" style={{backgroundColor: userColor}}>{follow.username.substring(0,1)}</div>
//                             <div className="list-item-label">{follow.username}</div>
//                         </div>
//                         {/* <img className="open-new-tab-icon" alt="open-new-tab" src={openNewTabIcon}></img> */}
//                     </div>
//                     )
//                 });
//             }else{
//                 return (<div className="empty-bracket-list">{this.emptyListMessage}</div>);
//             }

//             return listToView
//         }
//     }

//     render(){
        
        
        
//         return (
//             <>
                
//                 <div className="panel-tab-container">
//                     <div className="panel-tab" data-tab="following" onClick={this.handleSelectedTab}>Following</div>
//                     <div className="panel-tab" data-tab="followers" onClick={this.handleSelectedTab}>Followers</div>
//                 </div>
//                 <div className="bracket-id-list">
//                     {this.followDisplay}
//                 </div>
                
//             </>
//         );
//     }
// }

// export default NavigatorWrapper(FollowPanel);
    